var render = function render() {
  var _vm$pagePopUpConfig, _vm$pagePopUpConfig2, _vm$pagePopUpConfig3, _vm$pagePopUpConfig4, _vm$pagePopUpConfig5, _vm$pagePopUpConfig6, _vm$pagePopUpConfig7, _vm$pagePopUpConfig8, _vm$pagePopUpConfig9, _vm$pagePopUpConfig0, _vm$pagePopUpConfig1;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-modal"
  }, [((_vm$pagePopUpConfig = _vm.pagePopUpConfig) === null || _vm$pagePopUpConfig === void 0 ? void 0 : _vm$pagePopUpConfig.popUpPosition) == "bottom" ? _c("div", {
    staticClass: "bottom-page"
  }, [_c("a-tooltip", {
    attrs: {
      placement: "bottom"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(((_vm$pagePopUpConfig2 = _vm.pagePopUpConfig) === null || _vm$pagePopUpConfig2 === void 0 ? void 0 : _vm$pagePopUpConfig2.popUpTitle) || _vm.$t("投保提醒")) + " ")]), _c("h2", {
    staticClass: "page-h2"
  }, [_vm._v(_vm._s(((_vm$pagePopUpConfig3 = _vm.pagePopUpConfig) === null || _vm$pagePopUpConfig3 === void 0 ? void 0 : _vm$pagePopUpConfig3.popUpTitle) || _vm.$t("投保提醒")))])], 2), _c("div", {
    staticClass: "page-content"
  }, [_vm._v(_vm._s(((_vm$pagePopUpConfig4 = _vm.pagePopUpConfig) === null || _vm$pagePopUpConfig4 === void 0 ? void 0 : _vm$pagePopUpConfig4.popUpContent) || _vm.$t("投保提醒内容")))]), _c("div", {
    staticClass: "page-btn"
  }, [_c("a-tooltip", {
    attrs: {
      placement: "top"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(((_vm$pagePopUpConfig5 = _vm.pagePopUpConfig) === null || _vm$pagePopUpConfig5 === void 0 ? void 0 : _vm$pagePopUpConfig5.buttonName) || _vm.$t("确认")) + " ")]), _c("div", {
    staticClass: "btn1",
    style: "color:" + _vm.pagePopUpConfig.buttonFontColor + ";background-color:" + _vm.pagePopUpConfig.buttonBgColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("popupClick");
      }
    }
  }, [_vm._v(" " + _vm._s(((_vm$pagePopUpConfig6 = _vm.pagePopUpConfig) === null || _vm$pagePopUpConfig6 === void 0 ? void 0 : _vm$pagePopUpConfig6.buttonName) || _vm.$t("确认")) + " ")])], 2)], 1)], 1) : _c("div", {
    staticClass: "central-page"
  }, [_c("a-tooltip", {
    attrs: {
      placement: "bottom"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(((_vm$pagePopUpConfig7 = _vm.pagePopUpConfig) === null || _vm$pagePopUpConfig7 === void 0 ? void 0 : _vm$pagePopUpConfig7.popUpTitle) || _vm.$t("投保提醒")) + " ")]), _c("h2", {
    staticClass: "page-h2"
  }, [_vm._v(_vm._s(((_vm$pagePopUpConfig8 = _vm.pagePopUpConfig) === null || _vm$pagePopUpConfig8 === void 0 ? void 0 : _vm$pagePopUpConfig8.popUpTitle) || _vm.$t("投保提醒")))])], 2), _c("div", {
    staticClass: "page-content"
  }, [_vm._v(_vm._s(((_vm$pagePopUpConfig9 = _vm.pagePopUpConfig) === null || _vm$pagePopUpConfig9 === void 0 ? void 0 : _vm$pagePopUpConfig9.popUpContent) || _vm.$t("投保提醒内容")))]), _c("div", {
    staticClass: "page-btn"
  }, [_c("a-tooltip", {
    attrs: {
      placement: "top"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(((_vm$pagePopUpConfig0 = _vm.pagePopUpConfig) === null || _vm$pagePopUpConfig0 === void 0 ? void 0 : _vm$pagePopUpConfig0.buttonName) || _vm.$t("确认")) + " ")]), _c("div", {
    staticClass: "btn1",
    style: "color:" + _vm.pagePopUpConfig.buttonFontColor + ";background-color:" + _vm.pagePopUpConfig.buttonBgColor,
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.$emit("popupClick");
      }
    }
  }, [_vm._v(" " + _vm._s(((_vm$pagePopUpConfig1 = _vm.pagePopUpConfig) === null || _vm$pagePopUpConfig1 === void 0 ? void 0 : _vm$pagePopUpConfig1.buttonName) || _vm.$t("确认")) + " ")])], 2)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };